"use strict";
"use client";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var WebStackNavigator_exports = {};
__export(WebStackNavigator_exports, {
  createWebStackNavigator: () => createWebStackNavigator
});
module.exports = __toCommonJS(WebStackNavigator_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_core = require("@react-navigation/core");
var import_routers = require("@react-navigation/routers");
var import_react = require("react");
var import_WebStackView = require("./WebStackView");
function WebStackNavigator(param) {
  var { initialRouteName, children, screenOptions, headlessChildren, ...rest } = param;
  var { state, navigation, descriptors, NavigationContent } = (0, import_core.useNavigationBuilder)(import_routers.StackRouter, {
    ...rest,
    children,
    screenOptions,
    initialRouteName
  });
  (0, import_react.useEffect)(function() {
    var _navigation_addListener;
    return navigation === null || navigation === void 0 ? void 0 : (_navigation_addListener = navigation.addListener) === null || _navigation_addListener === void 0 ? void 0 : _navigation_addListener.call(navigation, "tabPress", function(e) {
      var isFocused = navigation.isFocused();
      requestAnimationFrame(function() {
        if (state.index > 0 && isFocused && !e.defaultPrevented) {
          navigation.dispatch({
            ...import_routers.StackActions.popToTop(),
            target: state.key
          });
        }
      });
    });
  }, [
    navigation,
    state.index,
    state.key
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NavigationContent, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_WebStackView.WebStackView, {
      state,
      navigation,
      descriptors,
      customChildren: headlessChildren
    })
  });
}
var createWebStackNavigator = (0, import_core.createNavigatorFactory)(WebStackNavigator);
//# sourceMappingURL=WebStackNavigator.js.map
